import { Component } from '@angular/core';

@Component({
  selector: 'app-account-error',
  standalone: false,
  templateUrl: './account-error.component.html',
  styleUrl: './account-error.component.scss'
})
export class AccountErrorComponent {

}
